<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="import-publications-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Import Publications
            </h4>
          </div>

          <div class="modal-body">
            <FormGroup name="file" label="File" :error="getError('file')">
              <input
                  v-if="uploadReady"
                  type="file"
                  class="form-control"
                  id="file"
                  @change="setFile($event.target.files[0])"
              >
            </FormGroup>

            <div v-if="headingsLoaded">
              <SelectFormGroup
                  v-model="columns.name"
                  name="name_column"
                  label="Name Column"
                  :error="getError('name_column')"
                  :options="headingOptions"
              />

              <SelectFormGroup
                  v-model="columns.theme"
                  name="theme_column"
                  label="Theme Column"
                  :error="getError('theme_column')"
                  :options="headingOptions"
              />

              <SelectFormGroup
                  v-model="columns.theme_description"
                  name="theme_description_column"
                  label="Theme Description Column"
                  :error="getError('theme_description_column')"
                  :options="headingOptions"
              />

              <SelectFormGroup
                  v-model="columns.target"
                  name="target_column"
                  label="Target Column"
                  :error="getError('target_column')"
                  :options="headingOptions"
              />

              <SelectFormGroup
                  v-model="columns.management_target"
                  name="management_target_column"
                  label="Management Target Column"
                  :error="getError('management_target_column')"
                  :options="headingOptions"
              />

              <SelectFormGroup
                  v-model="columns.content_deadline_reminder_at"
                  name="content_deadline_reminder_at_column"
                  label="Content Deadline Reminder At Column"
                  :error="getError('content_deadline_reminder_at_column')"
                  :options="headingOptions"
              />

              <SelectFormGroup
                  v-model="columns.content_deadline_at"
                  name="content_deadline_at_column"
                  label="Content Deadline At Column"
                  :error="getError('content_deadline_at_column')"
                  :options="headingOptions"
              />

              <SelectFormGroup
                  v-model="columns.publish_at"
                  name="publish_at_column"
                  label="Publish At Column"
                  :error="getError('publish_at_column')"
                  :options="headingOptions"
              />
            </div>
          </div>

          <div v-if="headingsLoaded" class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import FormGroup from '@/vendor/forms/FormGroups/Block/FormGroup'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'

export default {
  components: {FormGroup, SelectFormGroup},

  mixins: [Errors],

  props: ['publicationBasedChannel'],

  data() {
    return {
      file: null,
      uploadReady: true,
      headings: [],
      headingsLoaded: false,
      columns: {}
    }
  },

  mounted() {
    this.listenForClose()
  },

  computed: {
    headingOptions() {
      return this.headings.data.map(heading => {
        return {
          value: heading.name,
          label: heading.name
        }
      })
    }
  },

  methods: {
    listenForClose() {
      $('#import-publications-modal').on('hidden.bs.modal', this.reset)
    },

    submit() {
      http.post('/api/v2/publication-imports', this.getFormData())
          .then(() => {
            notify.success('The publications were imported')

            this.$emit('imported')

            $('#import-publications-modal').modal('hide')
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}

      this.uploadReady = false

      this.$nextTick(() => {
        this.uploadReady = true
      })

      this.headings = []

      this.headingsLoaded = false

      this.columns = {}
    },

    getFormData() {
      let formData = new FormData()

      formData.append('file', this.file)

      if (this.columns.name) {
        formData.append('name_column', this.columns.name)
      }

      if (this.columns.theme) {
        formData.append('theme_column', this.columns.theme)
      }

      if (this.columns.theme_description) {
        formData.append('theme_description_column', this.columns.theme_description)
      }

      if (this.columns.target) {
        formData.append('target_column', this.columns.target)
      }

      if (this.columns.management_target) {
        formData.append('management_target_column', this.columns.management_target)
      }

      if (this.columns.content_deadline_reminder_at) {
        formData.append('content_deadline_reminder_at_column', this.columns.content_deadline_reminder_at)
      }

      if (this.columns.content_deadline_at) {
        formData.append('content_deadline_at_column', this.columns.content_deadline_at)
      }

      if (this.columns.publish_at) {
        formData.append('publish_at_column', this.columns.publish_at)
      }

      formData.append('publication_channel_id', this.publicationBasedChannel.data.id)

      return formData
    },

    setFile(file) {
      this.file = file

      this.getHeadings()
    },

    getHeadings() {
      http.post('/api/v1/excel-heading-analyses', this.getHeadingsFormData())
          .then(response => {
            this.headings = response.data

            this.headingsLoaded = true
          })
          .catch(this.catchValidationErrors)
    },

    getHeadingsFormData() {
      let formData = new FormData()

      formData.append('file', this.file)

      return formData
    }
  }
}
</script>
